module.exports = __webpack_public_path__ + "img/img_series_113.0694f183.png";